<template>
  <div class="tab-group" v-if="tabList.length > 0">
    <div
      class="tab-group__title"
      :style="{
        color: itemStyle.titleColor,
      }"
    >
      {{ title }}
    </div>
    <VantTabs
      v-model="currentIndex"
      class="tab-group__tab-list"
      line-height="0"
      @click="handleTabClick"
    >
      <VantTab
        v-for="(tabItem, index) in tabList"
        :key="index"
        title-style="width:25%;padding:0;"
      >
        <template #title>
          <div
            class="tab-group__tab-item"
            :class="index === currentIndex && 'tab-group__tab-item--active'"
            :style="{
              color:
                index === currentIndex
                  ? itemStyle.itemTitleColorActive
                  : itemStyle.itemTitleColor,
              borderRadius: itemStyle.itemTitleBorderRadius,
              backgroundColor:
                index === currentIndex
                  ? itemStyle.itemTitleBkColorActive
                  : 'transparent',
            }"
          >
            {{ tabItem.tab_title }}
          </div></template
        ></VantTab
      >
    </VantTabs>
    <div
      class="tab-group__content"
      :style="{
        borderColor: itemStyle.itemInfoBorderColor,
      }"
    >
      <div class="tab-group__image">
        <van-image :src="tabList[currentIndex].src"></van-image>
      </div>
      <div class="tab-group__info">
        <div
          class="tab-group__info-title"
          :style="tabList[currentIndex].info_title_style"
          v-if="tabList[currentIndex].info_title"
          v-html="tabList[currentIndex].info_title"
        ></div>
        <div class="tab-group__info-item" v-if="tabList[currentIndex].info_dx">
          店型：
          <span :style="tabList[currentIndex].info_dx_style">
            {{ tabList[currentIndex].info_dx }}
          </span>
        </div>
        <div class="tab-group__info-item" v-if="tabList[currentIndex].info_mj">
          面积：
          <span
            :style="{
              color: tabList[currentIndex].info_color || '#fc6a20',
              ...tabList[currentIndex].info_mj_style,
            }"
          >
            {{ tabList[currentIndex].info_mj }}
          </span>
        </div>
        <div class="tab-group__info-item" v-if="tabList[currentIndex].info_tz">
          投资：
          <span
            :style="{
              color: tabList[currentIndex].info_color || '#fc6a20',
              ...tabList[currentIndex].info_tz_style,
            }"
          >
            {{ tabList[currentIndex].info_tz }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from "vant";

export default {
  components: {
    VantTab: Tab,
    VantTabs: Tabs,
  },
  props: {
    tabList: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "标准店型",
    },
    itemStyle: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  created() {
    // console.log("placeholder: ", this.itemStyle);
  },
  methods: {
    handleTabClick() {
      const tabItem = this.tabList[this.currentIndex];
      window.sensors.track("JoinPageClick", {
        join_module_name: "标准店型",
        join_name: tabItem.tab_title,
        join_destination_url: "",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .tab-group {
    width: 100%;
    height: 100%;

    &__title {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      margin-bottom: 24px;
    }

    &__tab-list {
      width: 100%;
      padding-bottom: 26px;
      justify-content: flex-start;
    }

    &__tab-item {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      //   width: 25%;
      width: 100%;
      height: 68px;
      line-height: 68px;
      flex-shrink: 0;
    }
    &__tab-item--active {
      background-color: #3eae2c;
      border-radius: 34px;
      overflow: hidden;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
    &__content {
      border-radius: 32px;
      border: 6px solid #0ac233;
      overflow: hidden;
      box-sizing: border-box;
    }
    &__image {
      width: 100%;
      height: 570px;
      overflow: hidden;
    }
    &__info {
      width: 100%;
      //   height: 240px;
      box-sizing: border-box;
      padding: 24px 40px;
      background-color: white;
    }
    &__info > div {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      text-align: left;
    }
    &__info-title {
      margin-bottom: 20px;
    }
    &__info-item {
      margin-bottom: 4px;
    }
  }
</style>
<style lang="scss">
  .tab-group {
    .van-tab__text {
      width: 100%;
    }
    .van-tabs__nav {
      padding: 0 !important;
    }
    .van-tab {
      width: 25% !important;
      flex: none;
    }
  }
</style>
